import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import Homepage from "./components/pages/homepage/Homepage";
import ContactUsPage from "./components/pages/ContactUsPage/ContactUsPage";
import BlogLists from "./components/pages/blogs/blogList/BlogLists";

import ScrollToTop from "./components/utility/ScrollToTop";
import Fix from "../src/components/utility/Fix";
import BlogDetails from "./components/pages/blogs/blogDetails/BlogDetails";
import MaleFertility from "./components/pages/servicePage/labtest/MaleFertility";
import FemaleFertility from "./components/pages/servicePage/labtest/FemaleFertility";
import WeightReduction from "./components/pages/servicePage/labtest/WeightReduction";
import GeneralCheckUp from "./components/pages/servicePage/labtest/GeneralCheckUp";
import Obesity from "./components/pages/servicePage/labtest/Obesity";
import FoodIntolerence from "./components/pages/servicePage/labtest/FoodIntolerence";
import DoctorOnCall from "./components/pages/servicePage/homecare/DoctorOnCall";
import STDtest from "./components/pages/servicePage/homecare/STDtest";
import IVDrops from "./components/pages/servicePage/homecare/IVDrops";
import BloodTest from "./components/pages/servicePage/homecare/BloodTest";
import Physiotherapy from "./components/pages/servicePage/homecare/Physiotherapy";
import PalliativeCare from "./components/pages/servicePage/homecare/PalliativeCare";
import IntimateWhiten from "./components/pages/servicePage/urology/IntimateWhiten";
import MaleInfertility from "./components/pages/servicePage/urology/MaleInfertility";
import OShot from "./components/pages/servicePage/urology/OShot";
import PShot from "./components/pages/servicePage/urology/PShot";
import Geriatric from "./components/pages/servicePage/physiotherapy/Geriatric";
import PainManagement from "./components/pages/servicePage/physiotherapy/PainManagement";
import Rehabilitation from "./components/pages/servicePage/physiotherapy/Rehabilitation";
import SportsInjury from "./components/pages/servicePage/physiotherapy/SportsInjury";
import WomenHealth from "./components/pages/servicePage/physiotherapy/WomenHealth";
import Scaling from "./components/pages/servicePage/dental/Scaling";
import Filling from "./components/pages/servicePage/dental/Filling";
import Extraction from "./components/pages/servicePage/dental/Extraction";
import RootCanal from "./components/pages/servicePage/dental/RootCanal";
import Dentures from "./components/pages/servicePage/dental/Dentures";
import DentalImplants from "./components/pages/servicePage/dental/DentalImplants";
import Veneers from "./components/pages/servicePage/dental/Veneers";
import Crown from "./components/pages/servicePage/dental/Crown";
import NightGuard from "./components/pages/servicePage/dental/NightGuard";
import Orthodontic from "./components/pages/servicePage/dental/Orthodontic";
import DentalBridges from "./components/pages/servicePage/dental/DentalBridges";
import GumDisease from "./components/pages/servicePage/dental/GumDisease";
import Teethwhiten from "./components/pages/servicePage/dental/Teethwhiten";
import HollywoodSmile from "./components/pages/servicePage/dental/HollywoodSmile";

import FullBodyLaser from "./components/pages/servicePage/laserhairremoval/laserhairremoval/FullBodyLaser";
import BikiniLaserHairRemoval from "./components/pages/servicePage/laserhairremoval/laserhairremoval/BikiniLaserHairRemoval";
import BeardLaser from "./components/pages/servicePage/laserhairremoval/laserhairremoval/BeardLaser";
import WeightLossIV from "./components/pages/servicePage/IVDrips/ivDrips/WeightLossIV";
import VitaminCIV from "./components/pages/servicePage/IVDrips/ivDrips/VitaminCIV";
import SkinGlowingIV from "./components/pages/servicePage/IVDrips/ivDrips/SkinGlowingIV";
import NADIVs from "./components/pages/servicePage/IVDrips/ivDrips/NADIVs";
import MultivitaminIV from "./components/pages/servicePage/IVDrips/ivDrips/MultivitaminIV";
import MemoryBoost from "./components/pages/servicePage/IVDrips/ivDrips/MemoryBoost";
import Maleenergyplus from "./components/pages/servicePage/IVDrips/ivDrips/Maleenergyplus";
import LiverDetox from "./components/pages/servicePage/IVDrips/ivDrips/LiverDetox";
import Immuneboost from "./components/pages/servicePage/IVDrips/ivDrips/Immuneboost";
import HairGenerateIV from "./components/pages/servicePage/IVDrips/ivDrips/HairGenerateIV";
import GlutathioneIV from "./components/pages/servicePage/IVDrips/ivDrips/GlutathioneIV";
import Femalebalance from "./components/pages/servicePage/IVDrips/ivDrips/Femalebalance";
import EnergyBoost from "./components/pages/servicePage/IVDrips/ivDrips/EnergyBoost";
import DiabeticSupport from "./components/pages/servicePage/IVDrips/ivDrips/DiabeticSupport";
import Cardiosupport from "./components/pages/servicePage/IVDrips/ivDrips/Cardiosupport";
import AntistressIV from "./components/pages/servicePage/IVDrips/ivDrips/AntistressIV";
import WeightLossInjections from "./components/pages/servicePage/weightlossSlimming/weightloss/WeightLossInjections";
import OzempicInjections from "./components/pages/servicePage/weightlossSlimming/weightloss/OzempicInjections";
import MounjaroWeightLoss from "./components/pages/servicePage/weightlossSlimming/weightloss/MounjaroWeightLoss";
import LipotropicInjections from "./components/pages/servicePage/weightlossSlimming/weightloss/LipotropicInjections";
import FatBurningInjections from "./components/pages/servicePage/weightlossSlimming/weightloss/FatBurningInjections";
import DietConsultation from "./components/pages/servicePage/weightlossSlimming/weightloss/DietConsultation";
import DiabetesManagement from "./components/pages/servicePage/weightlossSlimming/weightloss/DiabetesManagement";
import AqualyxFatBurning from "./components/pages/servicePage/weightlossSlimming/weightloss/AqualyxFatBurning";
import PowerShape from "./components/pages/servicePage/weightlossSlimming/slimming/PowerShape";
import PostNatalWeightLoss from "./components/pages/servicePage/weightlossSlimming/slimming/PostNatalWeightLoss";
import MaderoTherapy from "./components/pages/servicePage/weightlossSlimming/slimming/MaderoTherapy";
import Liposuction from "./components/pages/servicePage/weightlossSlimming/slimming/Liposuction";
import FatFreezing from "./components/pages/servicePage/weightlossSlimming/slimming/FatFreezing";
import Endosphere from "./components/pages/servicePage/weightlossSlimming/slimming/Endosphere";
import EMS from "./components/pages/servicePage/weightlossSlimming/slimming/EMS";
import Cryolipolysis from "./components/pages/servicePage/weightlossSlimming/slimming/Cryolipolysis";
import AntiCelluliteMassage from "./components/pages/servicePage/weightlossSlimming/slimming/AntiCelluliteMassage";
import LaserD from "./components/pages/servicePage/weightlossSlimming/slimming/Laser6D";
import Allerganbotox from "./components/pages/servicePage/aesthetics/botox/Allerganbotox";
import Dysportbotox from "./components/pages/servicePage/aesthetics/botox/Dysportbotox";
import Hyperhidrosisbotox from "./components/pages/servicePage/aesthetics/botox/Hyperhidrosisbotox";
import LipFlipbotox from "./components/pages/servicePage/aesthetics/botox/LipFlipbotox";
import Masseterbotox from "./components/pages/servicePage/aesthetics/botox/Masseterbotox";
import NabotaBotox from "./components/pages/servicePage/aesthetics/botox/NabotaBotox";
import Underarmbotox from "./components/pages/servicePage/aesthetics/botox/Underarmbotox";
import RejuvenationThreads from "./components/pages/servicePage/aesthetics/threads/RejuvenationThreads";
import PDOThreads from "./components/pages/servicePage/aesthetics/threads/PDOThreads";
import NoseThreads from "./components/pages/servicePage/aesthetics/threads/NoseThreads";
import FaceThreads from "./components/pages/servicePage/aesthetics/threads/FaceThreads";
import CollagenThreads from "./components/pages/servicePage/aesthetics/threads/CollagenThreads";
import ChinThreads from "./components/pages/servicePage/aesthetics/threads/ChinThreads";
import ProfhiloSkinBooster from "./components/pages/servicePage/aesthetics/boosters/ProfhiloSkinBooster";
import KarismaSkinBooster from "./components/pages/servicePage/aesthetics/boosters/KarismaSkinBooster";
import PRXT33Peel from "./components/pages/servicePage/aesthetics/chemicalpeels/PRXT33Peel";
import Melasma from "./components/pages/servicePage/aesthetics/chemicalpeels/Melasma";
import Hyperpigmentation from "./components/pages/servicePage/aesthetics/chemicalpeels/Hyperpigmentation";
import AcnePimplesTreatment from "./components/pages/servicePage/aesthetics/chemicalpeels/AcnePimplesTreatment";
import PRPForHair from "./components/pages/servicePage/aesthetics/prp/PRPForHair";
import PRPForFace from "./components/pages/servicePage/aesthetics/prp/PRPForFace";
import PRPBiotin from "./components/pages/servicePage/aesthetics/prp/PRPBiotin";
import Microneedling from "./components/pages/servicePage/aesthetics/mesotherapy/Microneedling";
import DermaRoller from "./components/pages/servicePage/aesthetics/mesotherapy/DermaRoller";
import DermaPen from "./components/pages/servicePage/aesthetics/mesotherapy/DermaPen";
import UnderEyeFillers from "./components/pages/servicePage/aesthetics/fillers/UnderEyeFillers";
import TeosyalFiller from "./components/pages/servicePage/aesthetics/fillers/TeosyalFiller";
import StylageFillers from "./components/pages/servicePage/aesthetics/fillers/StylageFillers";
import RevolaxFillers from "./components/pages/servicePage/aesthetics/fillers/RevolaxFillers";
import Nosefillers from "./components/pages/servicePage/aesthetics/fillers/Nosefillers";
import NasolabialFillers from "./components/pages/servicePage/aesthetics/fillers/NasolabialFillers";
import LipFillers from "./components/pages/servicePage/aesthetics/fillers/LipFillers";
import JuvidermFillers from "./components/pages/servicePage/aesthetics/fillers/JuvidermFillers";
import JawlineFiller from "./components/pages/servicePage/aesthetics/fillers/JawlineFiller";
import HyacorpButtFillers from "./components/pages/servicePage/aesthetics/fillers/HyacorpButtFillers";
import Chinfillers from "./components/pages/servicePage/aesthetics/fillers/Chinfillers";
import ButtFillers from "./components/pages/servicePage/aesthetics/fillers/ButtFillers";
import WartsRemoval from "./components/pages/servicePage/aesthetics/moleWartsSkintags/WartsRemoval";
import SkinTagsRemoval from "./components/pages/servicePage/aesthetics/moleWartsSkintags/SkinTagsRemoval";
import MoleRemoval from "./components/pages/servicePage/aesthetics/moleWartsSkintags/MoleRemoval";
import EarPiercings from "./components/pages/servicePage/aesthetics/piercings/EarPiercings";
import BellyPiercings from "./components/pages/servicePage/aesthetics/piercings/BellyPiercings";
import WrinkleReductions from "./components/pages/servicePage/aesthetics/secretRF/WrinkleReductions";
import Unevenskintonetexture from "./components/pages/servicePage/aesthetics/secretRF/Unevenskintonetexture";
import StretchMarks from "./components/pages/servicePage/aesthetics/secretRF/StretchMarks";
import SpiderVeins from "./components/pages/servicePage/aesthetics/secretRF/SpiderVeins";
import SkinTightening from "./components/pages/servicePage/aesthetics/secretRF/SkinTightening";
import SkinRejuvenation from "./components/pages/servicePage/aesthetics/secretRF/SkinRejuvenation";
import ScarsRemoval from "./components/pages/servicePage/aesthetics/secretRF/ScarsRemoval";
import RFMicroneedling from "./components/pages/servicePage/aesthetics/secretRF/RFMicroneedling";
import PoreReductions from "./components/pages/servicePage/aesthetics/secretRF/PoreReductions";
import FineLines from "./components/pages/servicePage/aesthetics/secretRF/FineLines";
import AcneScarsRemoval from "./components/pages/servicePage/aesthetics/secretRF/AcneScarsRemoval";
import FullbodyBotox from "./components/pages/servicePage/aesthetics/botox/FullbodyBotox";

import { GlobalDataProvider } from "./components/contextApi/globalContextData";
import ServiceTemplate from "./components/pages/servicePage/ServiceTemplate";
// import PageNotFound from "./components/utility/PageNotFound";

function App() {
  return (
    <GlobalDataProvider>
      <Router>
        <div className="App">
          <Navbar />
          <Fix />
          <Routes>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/home" element={<Homepage />} />
            <Route path="/contact" element={<ContactUsPage />} />
            <Route path="/blog" element={<BlogLists />} />

            {/* AESTHETIC */}

            {/* botox */}

            <Route
              path="/services/underarm-botox-dubai/"
              element={<Underarmbotox />}
            />
            <Route
              path="/services/hyperhidrosis-botox/"
              element={<Hyperhidrosisbotox />}
            />

            <Route
              path="/services/allergan-botox/"
              element={<Allerganbotox />}
            />
            <Route path="/services/dysport-botox/" element={<Dysportbotox />} />
            <Route
              path="/services/full-face-botox-dubai"
              element={<FullbodyBotox />}
            />

            <Route
              path="/services/botox-lip-flip/"
              element={<LipFlipbotox />}
            />
            <Route
              path="/services/masseter-botox/"
              element={<Masseterbotox />}
            />
            <Route path="/services/nabota-botox/" element={<NabotaBotox />} />

            {/* Threads Routes */}
            <Route
              path="/services/rejuvenation-threads/"
              element={<RejuvenationThreads />}
            />
            <Route path="/services/pdo-thread-lift/" element={<PDOThreads />} />
            <Route path="/services/nose-threads/" element={<NoseThreads />} />
            <Route path="/services/face-threads/" element={<FaceThreads />} />
            <Route
              path="/services/collagen-thread-lift/"
              element={<CollagenThreads />}
            />
            <Route path="/services/chin-threads/" element={<ChinThreads />} />
            {/* Boosters Routes */}
            <Route
              path="/services/profhilo-treatment-dubai/"
              element={<ProfhiloSkinBooster />}
            />
            <Route
              path="/services/karisma-skin-booster/"
              element={<KarismaSkinBooster />}
            />

            {/* Chemical Peels Routes */}
            <Route path="/services/prx-t33-peel/" element={<PRXT33Peel />} />
            <Route
              path="/services/melasma-treatment-dubai/"
              element={<Melasma />}
            />
            <Route
              path="/services/hyperpigmentation-treatment-in-dubai/"
              element={<Hyperpigmentation />}
            />
            <Route
              path="/services/acne-treatment-dubai/"
              element={<AcnePimplesTreatment />}
            />

            {/* PRP Routes */}
            <Route
              path="/services/prp-hair-treatment-dubai/"
              element={<PRPForHair />}
            />
            <Route path="/services/prp-for-face/" element={<PRPForFace />} />
            <Route path="/services/prp-biotin" element={<PRPBiotin />} />

            {/* Mesotherapy Routes */}
            <Route
              path="/services/microneedling-treatment-dubai/"
              element={<Microneedling />}
            />
            <Route path="/services/derma-roller/" element={<DermaRoller />} />
            <Route path="/services/dermapen/" element={<DermaPen />} />

            {/* Fillers Routes */}
            <Route
              path="/services/under-eye-fillers-dubai/"
              element={<UnderEyeFillers />}
            />
            <Route
              path="/services/teosyal-fillers/"
              element={<TeosyalFiller />}
            />
            <Route
              path="/services/stylage-fillers/"
              element={<StylageFillers />}
            />
            <Route
              path="/services/revolax-fillers/"
              element={<RevolaxFillers />}
            />
            <Route
              path="/services/nose-fillers-dubai/"
              element={<Nosefillers />}
            />
            <Route
              path="/services/nasolabial-fold-filler/"
              element={<NasolabialFillers />}
            />
            <Route
              path="/services/lip-fillers-dubai/"
              element={<LipFillers />}
            />
            <Route
              path="/services/juvederm-fillers/"
              element={<JuvidermFillers />}
            />
            <Route
              path="/services/jawline-fillers-dubai/"
              element={<JawlineFiller />}
            />
            <Route
              path="/services/hyacorp-butt-fillers/"
              element={<HyacorpButtFillers />}
            />
            <Route
              path="/services/chin-fillers-dubai/"
              element={<Chinfillers />}
            />
            <Route
              path="/services/butt-fillers-dubai/"
              element={<ButtFillers />}
            />

            {/* Mole, Warts, Skin Tags Routes */}
            <Route
              path="/services/warts-removal-dubai/"
              element={<WartsRemoval />}
            />
            <Route
              path="/services/skin-tags-removal-dubai/"
              element={<SkinTagsRemoval />}
            />
            <Route
              path="/services/mole-removal-dubai/"
              element={<MoleRemoval />}
            />

            {/* Piercings Routes */}
            <Route
              path="/services/ear-piercing-dubai/"
              element={<EarPiercings />}
            />
            <Route
              path="/services/belly-piercing-dubai/"
              element={<BellyPiercings />}
            />

            {/* Secret RF Routes */}
            <Route
              path="/services/wrinkle-reductions-dubai/"
              element={<WrinkleReductions />}
            />
            <Route
              path="/services/uneven-skin-tone-texture-dubai/"
              element={<Unevenskintonetexture />}
            />
            <Route
              path="/services/stretch-marks-dubai/"
              element={<StretchMarks />}
            />
            <Route
              path="/services/spider-veins-dubai/"
              element={<SpiderVeins />}
            />
            <Route
              path="/services/skin-tightening-dubai/"
              element={<SkinTightening />}
            />
            <Route
              path="/services/skin-rejuvenation-dubai/"
              element={<SkinRejuvenation />}
            />
            <Route
              path="/services/scars-removal-dubai/"
              element={<ScarsRemoval />}
            />
            <Route
              path="/services/rf-microneedling-dubai/"
              element={<RFMicroneedling />}
            />
            <Route
              path="/services/pore-reductions-dubai/"
              element={<PoreReductions />}
            />
            <Route path="/services/fine-lines-dubai/" element={<FineLines />} />
            <Route
              path="/services/acne-scars-removal-dubai/"
              element={<AcneScarsRemoval />}
            />

            {/* LASER */}

            <Route
              path="/services/laser-hair-removal/"
              element={<FullBodyLaser />}
            />
            <Route
              path="/services/bikini-laser-hair-removal/"
              element={<BikiniLaserHairRemoval />}
            />
            <Route
              path="/services/laser-hair-removal-beard/"
              element={<BeardLaser />}
            />

            {/* IVDrips */}

            <Route path="/weight-loss-iv" element={<WeightLossIV />} />
            <Route
              path="/services/vitamin-c-iv-drip/"
              element={<VitaminCIV />}
            />
            <Route path="/skin-glowing-iv" element={<SkinGlowingIV />} />
            <Route
              path="/services/nad-iv-therapy-dubai/  "
              element={<NADIVs />}
            />
            <Route
              path="/services/vitamin-iv-drip-dubai/"
              element={<MultivitaminIV />}
            />
            <Route
              path="/services/memory-boost-iv-drip/"
              element={<MemoryBoost />}
            />
            <Route
              path="/services/male-energy-plus-iv-drip/"
              element={<Maleenergyplus />}
            />
            <Route
              path="/services/liver-detox-iv-drip/"
              element={<LiverDetox />}
            />
            <Route path="/immune-boost" element={<Immuneboost />} />
            <Route
              path="/services/hair-generate-iv-drip/"
              element={<HairGenerateIV />}
            />
            <Route
              path="/services/glutathione-iv-drip/"
              element={<GlutathioneIV />}
            />
            <Route
              path="/services/female-balance-iv-drip/"
              element={<Femalebalance />}
            />
            <Route path="/energy-boost" element={<EnergyBoost />} />
            <Route
              path="/services/diabetic-support-iv-drip/"
              element={<DiabeticSupport />}
            />
            <Route
              path="/services/cardio-support-iv-drip/"
              element={<Cardiosupport />}
            />
            <Route
              path="/services/anti-stress-iv-drip/"
              element={<AntistressIV />}
            />

            {/* Wieghtloss & Slimming */}
            <Route
              path="/services/weight-loss-iv-drip-dubai/"
              element={<WeightLossIV />}
            />
            <Route
              path="/services/weight-loss-injections/"
              element={<WeightLossInjections />}
            />
            <Route
              path="/services/ozempic-injection/"
              element={<OzempicInjections />}
            />
            <Route
              path="/services/mounjaro-injection/"
              element={<MounjaroWeightLoss />}
            />
            <Route
              path="/services/lipotropic-injections/"
              element={<LipotropicInjections />}
            />
            <Route
              path="/services/fat-burning-injections/"
              element={<FatBurningInjections />}
            />
            <Route
              path="/services/best-dietician-in-dubai/"
              element={<DietConsultation />}
            />
            <Route
              path="/services/diabetes-management/"
              element={<DiabetesManagement />}
            />
            <Route
              path="/services/aqualyx-fat-burning-injections/"
              element={<AqualyxFatBurning />}
            />

            {/* Slimming Routes */}
            <Route
              path="/services/powershape-ultimate-body-sculpting/"
              element={<PowerShape />}
            />
            <Route
              path="/services/postnatal-weight-loss/"
              element={<PostNatalWeightLoss />}
            />
            <Route
              path="/services/madero-therapy-in-dubai/"
              element={<MaderoTherapy />}
            />
            <Route
              path="/services/liposuction-treatment-in-dubai/"
              element={<Liposuction />}
            />
            <Route
              path="/services/fat-freezing-coolsculpting-dubai/"
              element={<FatFreezing />}
            />
            <Route path="/endosphere" element={<Endosphere />} />
            <Route path="/services/ems-treatment-in-dubai/" element={<EMS />} />
            <Route
              path="/services/cryolipolysis/"
              element={<Cryolipolysis />}
            />
            <Route
              path="/services/anti-cellulite-massage-dubai/"
              element={<AntiCelluliteMassage />}
            />
            <Route path="/6d-laser" element={<LaserD />} />

            {/* LABTEST */}
            <Route
              path="/services/male-fertility-package/"
              element={<MaleFertility />}
            />
            <Route
              path="/services/female-fertility-package/"
              element={<FemaleFertility />}
            />
            <Route
              path="/services/weight-reduction-program/"
              element={<WeightReduction />}
            />
            <Route
              path="/services/general-health-check-up-package/"
              element={<GeneralCheckUp />}
            />
            <Route path="/services/obesity-profile/" element={<Obesity />} />
            <Route path="/food-intolerence" element={<FoodIntolerence />} />

            {/* HOMECARE */}
            <Route
              path="/services/doctor-on-call-dubai/"
              element={<DoctorOnCall />}
            />
            <Route path="/services/std-test-dubai/" element={<STDtest />} />
            <Route
              path="/services/iv-drip-at-home-dubai/"
              element={<IVDrops />}
            />
            <Route
              path="/services/blood-test-at-home-dubai/"
              element={<BloodTest />}
            />
            <Route
              path="/services/physiotherapy-dubai/"
              element={<Physiotherapy />}
            />
            <Route
              path="/services/palliative-care-services/"
              element={<PalliativeCare />}
            />

            {/* UROLOGY */}
            <Route
              path="/vaginal-bleaching-treatment-dubai"
              element={<IntimateWhiten />}
            />
            <Route
              path="/services/male-infertility-treatment-dubai/"
              element={<MaleInfertility />}
            />
            <Route
              path="/services/o-shot-treatment-dubai/"
              element={<OShot />}
            />
            <Route
              path="/services/p-shot-treatment-dubai/"
              element={<PShot />}
            />

            {/* PHYSIOTHERAPY */}
            <Route
              path="/services/geriatric-medicine-services-in-dubai/"
              element={<Geriatric />}
            />
            <Route
              path="/services/pain-management/"
              element={<PainManagement />}
            />
            <Route
              path="/services/rehabilitation/"
              element={<Rehabilitation />}
            />
            <Route
              path="/services/sport-injuries/"
              element={<SportsInjury />}
            />
            <Route
              path="/services/womens-health-services-in-dubai/"
              element={<WomenHealth />}
            />

            {/* DENTAL */}
            <Route
              path="/services/teeth-cleaning-dubai/"
              element={<Scaling />}
            />
            <Route
              path="/services/tooth-filling-dubai/"
              element={<Filling />}
            />
            <Route
              path="/services/tooth-extraction-dubai/"
              element={<Extraction />}
            />
            <Route
              path="/services/root-canal-treatment-dubai/"
              element={<RootCanal />}
            />
            <Route
              path="/services/denture-teeth-dubai/"
              element={<Dentures />}
            />
            <Route
              path="/services/dental-implants-in-dubai/"
              element={<DentalImplants />}
            />
            <Route
              path="/services/dental-veneers-dubai/"
              element={<Veneers />}
            />
            <Route path="/services/dental-crowns-dubai/" element={<Crown />} />
            <Route path="/services/night-guard/" element={<NightGuard />} />
            <Route
              path="/services/orthodontics-dubai/"
              element={<Orthodontic />}
            />
            <Route
              path="/services/dental-bridges-dubai/"
              element={<DentalBridges />}
            />
            <Route
              path="/services/gum-disease-laser-treatment/"
              element={<GumDisease />}
            />
            <Route
              path="/services/teeth-whitening-dubai/"
              element={<Teethwhiten />}
            />
            <Route
              path="/services/hollywood-smile-dubai/"
              element={<HollywoodSmile />}
            />
            <Route path="/blog-details" element={<BlogDetails />} />
            {/* <Route path="/service_template" element={<ServiceTemplate />} /> */}
          </Routes>

          <Footer />
          <ScrollToTop />
          <ToastContainer />
        </div>
        {/* <Routes>
          <Route path="*" element={<PageNotFound />} />
        </Routes> */}
      </Router>
    </GlobalDataProvider>
  );
}

export default App;
